import Component from 'vue-class-component'
import Vue from 'vue'

@Component({
  name: 'reactButton',
  props: ['isReacted', 'numReactions', 'name', 'icon']
})
export default class ReactButton extends Vue {
  get nameStyle () {
    return this.$props['isReacted'] ? 'font-weight: bold' : 'font-weight: normal'
  }

  get action () {
    return this.$props['isReacted'] ? 'toggleOff' : 'toggleOn'
  }

  get type () {
    if (this.$props['icon'].indexOf('fa-') >= 0) return null
    return this.$props['isReacted'] ? 'fas' : 'fal'
  }
}
